module.exports = __webpack_public_path__ + "static/media/bcur.db396af7.png";